import { createContext, useContext } from 'react';
import { plainTextLength } from '@worldcoo/shared/core';
import { cn } from '../../lib/utils';

export interface RecommendedLength {
	min: number;
	max: number;
}

/** This package has no lingui; the app builds the whole sentence, so a translation can reorder it. */
export type CharacterCountLabel = (args: { count: number; min: number; max: number }) => string;

const defaultCharacterCountLabel: CharacterCountLabel = ({ count, min, max }) => `${count}/${min}-${max} characters`;

const CharacterCountLabelContext = createContext(defaultCharacterCountLabel);
export const CharacterCountLabelProvider = CharacterCountLabelContext.Provider;

export function CharacterCount(props: { value: string; recommended: RecommendedLength; isHtml?: boolean }) {
	// The validators' own count, so the counter never says a rejected value fits.
	const count = props.isHtml ? plainTextLength(props.value) : props.value.length;
	const { min, max } = props.recommended;
	const isUnder = count < min;
	const isOver = count > max;
	const isInRange = !isUnder && !isOver;
	const label = useContext(CharacterCountLabelContext);

	return (
		<p
			className={cn(
				'm-2 text-xs',
				isInRange ? 'text-emerald-600' : isOver ? 'text-destructive' : 'text-muted-foreground',
			)}
		>
			{label({ count, min, max })}
		</p>
	);
}
